import { customTV } from '../../utils/tailwind';
// toaster class is here to exclude it from focus trapping
export const toaster = customTV({
    base: 'toaster rounded-12 bg-background-overlay dark:bg-background-overlay-dark shadow-high pointer-events-none fixed bottom-[--bottom] left-[--left] right-[--right] top-[--top] z-[--z-index] m-16 flex max-w-[calc(100%-32px)] items-start justify-between p-16 opacity-0 [transition:opacity_500ms_cubic-bezier(0.4,0,0.2,1),transform_150ms_cubic-bezier(0.4,0,0.2,1)]',
    variants: {
        opened: {
            true: 'pointer-events-auto opacity-100',
        },
    },
});
export const toasterContent = customTV({
    base: 'flex w-[300px] flex-grow flex-col',
});
